import CommonUserStructure from "../Constants/CommonUserStructure"; // adjust path

export const FetchUserData = async () => {
  try {
    const response = await fetch("/api/mock/SinglePage/UserDetailedinfo.json");
    const data = await response.json();
    const formattedData = {
      ...CommonUserStructure,
      userId: data.userId || "",
      userUUID: data.userUUID || "",
      name: {
        firstName: data.name?.firstName || "",
        lastName: data.name?.lastName || ""
      },
      imageUrl: data.imageUrl || "",
      gender: data.gender || "",
      ethenic: data.ethenic || "",
      email: data.email || "",
      password: data.password || "",
      mobileNumber: data.mobileNumber || "",
      devices: data.devices || [],
      dateOfBirth: data.dateOfBirth || "",
      address: {
        street: data.address?.street || "",
        city: data.address?.city || "",
        state: data.address?.state || "",
        zipCode: data.address?.zipCode || "",
        country: data.address?.country || ""
      }
    };

    return formattedData;
  } catch (error) {
    console.error("Failed to fetch user with profiles data:", error);
    return null;
  }
};
